// extracted by mini-css-extract-plugin
module.exports = {"seeMoreHeader":"SeeMoreModal_seeMoreHeader__2pT57","noTabs":"SeeMoreModal_noTabs__22Qfn","title":"SeeMoreModal_title__39dJh"};